import { render, staticRenderFns } from "./DictionarySelect.vue?vue&type=template&id=6b504580&scoped=true"
import script from "./DictionarySelect.vue?vue&type=script&lang=js"
export * from "./DictionarySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b504580",
  null
  
)

export default component.exports